{
  "version": 1,
  "asset_id": "f990ea6a-2396-4708-a286-8b8aa270997e",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/f990ea6a-2396-4708-a286-8b8aa270997e/beylikduzu-hizli-elektrikci-7-24-dukkan-1.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/f990ea6a-2396-4708-a286-8b8aa270997e/beylikduzu-hizli-elektrikci-7-24-dukkan-1.jpg",
  "original_filename": "beylikduzu-hizli-elektrikci-7-24-dukkan-1.jpg",
  "size": 508396,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T08:13:29Z"
}
